import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ShortenUrlSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: ShortenUrlSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: ShortenUrlSettings;
  error?: string;
}> = (props) => {
  const { control, handleSubmit, errors, watch } = useForm<ShortenUrlSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderApiKey = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">API Key</label>
          <Controller
            control={control}
            rules={{
              required: 'API Key is required',
            }}
            name="apiKey"
            defaultValue={props.data?.apiKey}
            render={({ onChange, value, name }) => (
              <input
                type="password"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="API Key"
                name={name}
                value={value}
                onChange={onChange}
                id="apiKey"
              />
            )}
          />
          <ErrorMessage>{errors.apiKey?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderBaseUrl = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Base Url</label>
          <Controller
            control={control}
            rules={{
              required: 'Base Url is required',
              validate: {
                validUrl: (value) => validator.isURL(value) || 'Invalid URL',
              },
            }}
            name="apiUrl"
            defaultValue={props.data?.apiUrl}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Api Url"
                name={name}
                value={value}
                onChange={onChange}
                id="apiUrl"
              />
            )}
          />
          <ErrorMessage>{errors.apiUrl?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderDomain = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Website ID</label>
          <Controller
            control={control}
            rules={{
              required: 'Domain is required',
            }}
            name="domain"
            defaultValue={props.data?.domain}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Domain"
                name={name}
                value={value}
                onChange={onChange}
                id="domain"
              />
            )}
          />
          <ErrorMessage>{errors.domain?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Shorten URL Settings
        </h4>
        <div className="row gutter-10">
          {renderBaseUrl()}
          {renderApiKey()}
          {renderDomain()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
